import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../LanguageProvider";
import logo from "../../../assets/language-hero-logo.png";
import usaFlag from "../../../assets/flag-usa.svg";
import spainFlag from "../../../assets/flag-spain.svg";
import "./Header.css";

const Header = () => {
  const { t } = useTranslation();
  const { language, changeLanguage } = useLanguage();
  const [open, setOpen] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setOpen(true);
  }, [location.pathname]);

  const navClass = ({ isActive }) =>
    `site-nav__link${isActive ? " site-nav__link--active" : ""}`;

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="site-brand" aria-label="Language Hero home">
          <img src={logo} alt="Language Hero" className="site-brand__logo" />
          <span className="site-brand__copy">
            <span className="site-brand__name">LANGUAGE HERO</span>
            <span className="site-brand__tagline">INTERPRETATION &amp; TRANSLATION SERVICES</span>
          </span>
        </Link>

        <button
          className={`site-menu-toggle${open ? " site-menu-toggle--open" : ""}`}
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className="site-nav site-nav--desktop" aria-label="Primary navigation">
          <NavLink className={navClass} to="/" end>{t("home")}</NavLink>
          <NavLink className={navClass} to="/services">{t("services")}</NavLink>
          <NavLink className={navClass} to="/about">{t("aboutUs")}</NavLink>
          <NavLink className={navClass} to="/location">{t("location")}</NavLink>
          <NavLink className={navClass} to="/contact">{t("contact")}</NavLink>
        </nav>

        <div className="site-header__actions site-header__actions--desktop">
          <div className="language-switch" aria-label="Language selector">
            <button
              type="button"
              aria-label="English"
              title="English"
              className={language === "en" ? "is-active" : ""}
              onClick={() => changeLanguage("en")}
            >
              <img src={usaFlag} alt="" aria-hidden="true" />
            </button>
            <span aria-hidden="true">|</span>
            <button
              type="button"
              aria-label="Español"
              title="Español"
              className={language === "es" ? "is-active" : ""}
              onClick={() => changeLanguage("es")}
            >
              <img src={spainFlag} alt="" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      <div className={`mobile-nav${open ? " mobile-nav--open" : ""}`}>
        <nav className="mobile-nav__links" aria-label="Mobile navigation">
          <NavLink className={navClass} to="/" end>{t("home")}</NavLink>
          <NavLink className={navClass} to="/services">{t("services")}</NavLink>
          <NavLink className={navClass} to="/about">{t("aboutUs")}</NavLink>
          <NavLink className={navClass} to="/location">{t("location")}</NavLink>
          <NavLink className={navClass} to="/contact">{t("contact")}</NavLink>
        </nav>
        <div className="mobile-nav__bottom">
          <div className="language-switch">
            <button type="button" aria-label="English" title="English" className={language === "en" ? "is-active" : ""} onClick={() => changeLanguage("en")}><img src={usaFlag} alt="" aria-hidden="true" /></button>
            <span aria-hidden="true">|</span>
            <button type="button" aria-label="Español" title="Español" className={language === "es" ? "is-active" : ""} onClick={() => changeLanguage("es")}><img src={spainFlag} alt="" aria-hidden="true" /></button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
